export const isValidRelativePath = (redirectUrl?: string) => {
  if (!redirectUrl) return false;

  // Block potentially dangerous protocols before decoding
  // eslint-disable-next-line no-script-url
  const dangerousProtocols = ['javascript:', 'data:', 'vbscript:'];
  if (
    dangerousProtocols.some((protocol) =>
      redirectUrl.toLowerCase().includes(protocol),
    )
  ) {
    return false;
  }

  // Decode the URL if it's encoded
  let decodedUrl: string;
  try {
    decodedUrl = decodeURIComponent(redirectUrl);
  } catch {
    // If decoding fails, the URL is invalid
    return false;
  }

  // Regex breakdown:
  // ^(?!\/\/) – Must not start with //
  // \/ – Must start with a single slash
  // (?:[\w-./]+)? – Optional path segment with word characters, hyphens, dots, and forward slashes
  // (?:\?[^<>#]*)? – Optional query string (allow most characters except dangerous ones)
  // (?:#[\w-\s]*)? – Optional hash fragment with limited characters (including spaces)
  // $ – End of string
  const re = /^(?!\/\/)\/(?:[\w-./]+)?(?:\?[^<>#]*)?(?:#[\w-\s]*)?$/;

  // Additional validation for specific cases
  if (re.test(decodedUrl)) {
    // Check for invalid query parameter format
    if (decodedUrl.includes('?=')) {
      return false;
    }

    // Check for invalid hash fragment format
    if (decodedUrl.endsWith('#')) {
      return false;
    }

    // Check for invalid characters in path
    if (/[<>]/.test(decodedUrl.split('?')[0])) {
      return false;
    }

    // Check for invalid query parameter separators
    if (decodedUrl.includes(';;')) {
      return false;
    }

    // Check for multiple hash fragments
    if ((decodedUrl.match(/#/g) || []).length > 1) {
      return false;
    }

    // Check for invalid query parameter encoding
    if (decodedUrl.includes('?') && /%[^0-9A-Fa-f]/.test(decodedUrl)) {
      return false;
    }

    // Check for control characters using a different approach
    for (let i = 0; i < decodedUrl.length; i++) {
      const charCode = decodedUrl.charCodeAt(i);
      if (charCode < 32 || charCode === 127) {
        return false;
      }
    }

    return true;
  }

  return false;
};
